import { Injectable } from '@angular/core';
import { StarbaseDataService } from 'starbase-launcher';
import { LU_ContactType_ext } from '../models/lu_contacttype';
import { WebApiService } from 'starbase-login';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class LuContactTypeService extends StarbaseDataService<LU_ContactType_ext> {

  protected _staleDataTimeout = 2000;
  protected _getOneUri: string;
  protected _getAllUri = '/api/LU_ContactType';
  protected _postUri = '/api/LU_ContactType';
  protected _putUri = '/api/LU_ContactType/';
  protected _deleteUri = '/api/LU_ContactType/';
  protected _broadSearchUri = '/api/LU_ContactType/GetAllByPagination';

  constructor(private _http: HttpClient, private _webApi: WebApiService) {
    super(_http, _webApi);
   }

  // getDataByFilterParamsBroadSearch(url: string, filterParams: FilterParams<LU_ContactType_ext>): Observable<FilterParams<LU_ContactType_ext>> {
  //   filterParams.collection = [];
  //   return this._http.post<FilterParams<LU_ContactType_ext>>(
  //     this.server + url, filterParams, { headers: this._webApi.getApiHeaders('post')}
  //   ).pipe(retry(this.defaultRetries),
  //     catchError(e => this._webApi.handleRequestError(e)));
  // }
}
